module.exports = __webpack_public_path__ + "img/plan-01-mobile.5ee0680e.png";